<style>
    footer {
        background: #222;
        text-align: center;
        color: #eee;
        padding: 1rem 0;
    }
</style>

<footer>
    <p></p>
</footer>